export const recommendation = {
  intervention: {
    cost: {
      label: "Coût",
    },
    dueDate: {
      label: "Date d'échéance",
    },
    interventionType: {
      label: "Type d'intervention",
    },
    startDate: {
      label: "Date de début",
    },
  },
  add: {
    label: "Nouvelle recommandation",
    title: "Créer une nouvelle recommandation",
  },
  select: {
    placeholder: "Sélectionner une recommandation existante",
    emptyPlaceholder: "Aucune recommandation existante",
  },
  delete: {
    label: "Supprimer la recommandation",
  },
  disassociate: {
    label: "Dissocier la recommandation",
  },
  recommendedBy: {
    label: "Recommandé par ",
  },
  noRecommendations: {
    active: "Aucune recommandation",
    enable: {
      label: "Aucune recommandation",
      title: 'Ajouter l\'état "aucune recommandation"',
    },
    disable: {
      label: "Aucune recommandation",
      title: 'Supprimer l\'état "aucune recommandation"',
    },
  },
  staticState: {
    missing: "Recommandations manquantes",
    not_required: "Aucune recommandation",
    in_progress: "Recommandations non complétées",
    completed: "Recommandations complétées",
  },
};
